
const $ = jQuery;

$(document).ready(() => {
    const body = $('body');
    const burgerNav = $('#burger-navigation');

    $('.open-burger-nav').on('click', (event) => {
        event.preventDefault();

        // body.scrollTop(0);
        body.css('overflow', 'hidden');
        burgerNav.addClass('burger-open');
    });

    $('.close-burger-nav').on('click', (event) => {
        event.preventDefault();

        body.css('overflow', 'visible');
        burgerNav.removeClass('burger-open');
    });
});
